'use strict';

const jQuery = require('jquery');

const IndexTpl = require('./template/index.hbs');
const ItemTpl = require('./template/item.hbs');

module.exports.create = (config) => {
    let $tpl = jQuery(IndexTpl());
    let items = config.items || [];
    let $rootItems = $tpl.find('.items-root');

    const onItemClick = (item) => {
        if (typeof config.onItemClick === 'function') {
            config.onItemClick(item);
        }
    };

    const onShowChildrenClick = (item, $container, e) => {
        let $target = jQuery(e.currentTarget);
        if (typeof config.onShowChildren === 'function') {
            $target.toggleClass('shown');

            if ($container.children().length) {
                $container.toggleClass('d-none');
            } else {
                config.onShowChildren(item).then((info) => {
                    appendChildren(info.children, $container);
                });
            }
        }
    };

    const appendChildren = (children, $container) => {
        children.forEach((child) => {
            $container.append(createItem(child));
        });
    };

    const createMoreBtn = (item, $container) => {
        let $more = jQuery('<span class="more">+</span>');

        $more.on('click', function() {
            if (typeof config.onMoreClick === 'function') {
                config.onMoreClick(item).then((info) => {
                    appendChildren(info.children, $container);

                    $more.remove();

                    if (info.more) {
                        createMoreBtn(null, $container);
                    }
                });
            }
        });

        $container.append($more);
    };


    const createItem = (item) => {
        if (config.maxLevel === 1) {
            item.more = false;
        }

        let $item = jQuery(ItemTpl(item));
        let $items = $item.find('.items');

        $item.find('.tag-label').on('click', function() {
            onItemClick(item);
        });

        $item.find('.show-children').on('click', function(e) {
            onShowChildrenClick(item, $items, e);
        });

        if (item.showChildren) {
            $item.find('.show-children').click();
        }

        return $item;
    };

    items.forEach((item) => {
        $rootItems.append(createItem(item));
    });

    if (config.rootMore) {
        createMoreBtn(null, $rootItems);
    }

    if (config.appendTo) {
        config.appendTo.append($tpl);
    }

    return $tpl;
};
